import { useSectors } from "@cabukaka/hooks"
import { TabItem } from "../components/navigation/shared/HorizontalTab"
import HorizontalTabLayout from "./HorizontalTabLayout"
import { useNavigate } from "react-router-dom"
import { ReactNode, useEffect, useState } from "react"
import useCustomParams from "../hooks/params/useCustomParams"


interface SectorsTabLayoutProps {
    children: ReactNode
}
export default function SectorsTabLayout({ children }: SectorsTabLayoutProps) {
    const { sectors } = useSectors()
    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState('')
    const { sector } = useCustomParams()
    const sectorsTab: TabItem[] = sectors.map((sector) => {

        return {
            label: sector.name,
            value: sector.slug
        }
    })

    const handleChangeSector = (tab: string) => {
        setActiveTab(tab)
        navigate(`/admin/categories?sector=${tab}`)
    }

    useEffect(() => {
        if (sector) {
            setActiveTab(sector)

        }
    }, [sector])

    return (
        <HorizontalTabLayout activeTab={activeTab} onChange={handleChangeSector} tabs={sectorsTab} >
            {children}
        </HorizontalTabLayout>
    )
}
